import { useEffect } from 'react';

export const Resume = (): JSX.Element => {
  // Redirect to the PDF file
  useEffect(() => {
    window.location.href = '/resume.pdf';
  }, []);

  // Show a brief loading message while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black">
      <div className="text-center">
        <p className="text-lg [font-family:'ItemsTextTrial-Light',Helvetica] font-light text-black dark:text-white">
          Opening resume...
        </p>
      </div>
    </div>
  );
};
